import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import AppDetailReflection from "@/views/MGT/AppDetail/AppDetailCom/app-detail-reflection.vue";
import AppDetailPointModal from "@/views/MGT/AppDetail/AppDetailModal/app-detail-point-modal.vue";
import { departmentBindingTree, saveDepartmentMappings } from "@/service/appList.js";
export default {
  name: "AppDetailTab5",
  components: {
    AppDetailReflection,
    AppDetailPointModal
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      activeValue: "PMS",
      treeData: [],
      retVal: {}
    };
  },
  computed: {
    // 第三方钉钉
    _isThirdDingDing() {
      return this.detail.appId === "ID_UPSTREAM_DING_TALK";
    },
    // 企业微信
    _isEnterpriseWechat() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_PRIVATE";
    },
    // 企业微信通讯录同步应用
    _isEnterpriseWechatSync() {
      return this.detail.appId === "ID_UPSTREAM_WECHAT_WORK_SYNC";
    },
    // opera
    _isOperaCloud() {
      return this.detail.appId === "ID_OPERA_CLOUD";
    },
    // 上游系统标识
    _upstream() {
      let value = "";
      if (this._isThirdDingDing) {
        value = "DING_TALK";
      } else if (this._isEnterpriseWechat || this._isEnterpriseWechatSync) {
        value = "WE_CHAT_WORK_PRIVATE";
      } else if (this._isOperaCloud) {
        value = "IWORK_UPSTREAM_MIRROR";
      }
      return value;
    },
    // 隐藏左侧菜单栏
    _hideMenu() {
      return this._isOperaCloud;
    },
    // 下游系统标识
    _downstream() {
      if (this._isOperaCloud) {
        return "OPERA_CLOUD";
      } else {
        return this.activeValue;
      }
    },
    // 组织结构左侧显示文案
    _leftTitle() {
      let value = "";
      if (this._isThirdDingDing) {
        value = $t("8yukcv6", "钉钉组织架构");
      } else if (this._isEnterpriseWechat) {
        value = $t("mdi88t8", "企业微信组织架构");
      } else if (this._isOperaCloud) {
        value = $t("4tkmln9", "iWork组织架构");
      }
      return value;
    },
    // 组织结构右侧显示文案
    _rightTitle() {
      let value = "";
      if (this._isThirdDingDing) {
        value = $t("izku6b6", "绿云组织架构");
      } else if (this._isEnterpriseWechat) {
        value = $t("izku6b6", "绿云组织架构");
      } else if (this._isOperaCloud) {
        value = $t("vx8gvhe", "OperaCloud组织架构");
      }
      return value;
    }
  },
  mounted() {
    this.getTree();
  },
  methods: {
    /*
     * 获取所有树
     */
    async getTree() {
      let params = {
        upstream: this._upstream,
        downstream: this._downstream
      };
      this.loading = true;
      let res = await departmentBindingTree(params);
      this.loading = false;
      if (res.data && res.data.result == 0) {
        this.retVal = res.data.retVal;
        this.changeRetVal(res.data.retVal);
      } else {
        this.retVal = {};
        this.treeData = [];
      }
    },
    /*
     * 兼容组件数据处理
     */
    changeRetVal(retVal) {
      let tree = [retVal.virtualRoot];
      let change = (arr, father = null) => {
        arr.forEach(v => {
          // 配置参数设置
          this.setParams(v, father);
          let children = v.children;
          if (children && children.length > 0) {
            change(children, v);
          }
        });
      };
      change(tree);
      this.treeData = tree;
    },
    /*
     * 配置参数设置
     */
    setParams(v, father) {
      // 记录父级
      v.father = father;
      // 左边显示标题
      v.title = v.name;
      // 默认展开
      this.$set(v, "expand", true);
      // 右边是否显示关联功能
      v.bindVisible = v.mutable && v.bindingNodeType === "DEPARTMENT";
      // 可读不可写
      v.disabled = !v.mutable;
      // 右边没有关联时候的标题
      v.bindTitle = $t("atc0ld4", "关联部门");
      // 没有关联(bindingState:对于部门-部门映射, BIND: 已建立关联关系, MATCH: 没有关联关系, 通过名字匹配到下游部门; NULL: 没有关联和匹配)
      v.noBind = v.bindingState === "NULL";
      // 关联的名称
      v.bindName = `${v.downstream.name} (${v.downstream.code})`;
    },
    /*
     * 解除关联
     */
    async onDeleteBind(data) {
      let params = {
        session: this.retVal.session,
        upstream: this._upstream,
        downstream: this._downstream,
        mappings: {
          upstreamDepartmentId: data.upstreamDepartmentId,
          unitCode: "",
          downstreamDepartmentKey: "",
          downstreamParentKey: "",
          downstreamDepartmentCode: "",
          downstreamDepartmentName: ""
        }
      };
      this.loading = true;
      let res = await saveDepartmentMappings(params);
      this.loading = false;
      if (res.data && res.data.result == 0) {
        this.$Message.success($t("jk1gy76", "解除关联成功"));
        this.getTree();
      }
    },
    /*
     * 获取对应的数据（部门）
     */
    getTreeData(rowItem) {
      let treeData = [];
      // 获取对应根节点数据
      let change = arr => {
        arr.forEach(v => {
          if (v.unitCode === rowItem.father.downstream.unitCode) {
            treeData.push(v);
            return;
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(this.retVal.downstreamCandidates);

      // 深拷贝，断开原先的数据的联系，并处理树形数据
      treeData = JSON.parse(JSON.stringify(treeData));
      let configTree = arr => {
        arr.forEach(v => {
          v.title = v.name || v.unitName;
          v.code = v.code || v.unitCode;
          v.expand = true;
          // 如果已存在关联部门则默认勾选
          if (!rowItem.noBind && rowItem.downstream.key === v.key) {
            v.webChecked = true;
          } else {
            v.webChecked = false;
          }
          let children = v.children;
          if (children && children.length > 0) {
            configTree(children);
          }
        });
      };
      configTree(treeData);

      // 第一层不可选择
      if (treeData.length > 0) {
        treeData[0].disabled = true;
      }
      return treeData;
    },
    /*
     * 打开映射弹窗
     */
    onOpenBind(item, type) {
      let treeData = [];
      // if (type === "issue") {
      //   treeData = this.getTreeDataIssue();
      // } else {
      treeData = this.getTreeData(item);
      // }
      this.$refs.AppDetailPointModal.open(treeData, item, type);
    },
    /*
     * 关联
     */
    onSubmitBind(data, rowItem, type) {
      // 下发
      if (type === "issue") {
        this.issueSubmit(data);
      }
      // 部门提交
      else {
        this.orgSubmit(data, rowItem);
      }
    },
    /*
     * 部门提交
     */
    async orgSubmit(data, rowItem) {
      let dataValue = data.length > 0 ? data[0] : {};
      let {
        unitCode = "",
        key = "",
        parentKey = "",
        code = "",
        name = ""
      } = dataValue;
      let params = {
        session: this.retVal.session,
        upstream: this._upstream,
        downstream: this._downstream,
        mappings: {
          upstreamDepartmentId: rowItem.upstreamDepartmentId,
          unitCode,
          downstreamDepartmentKey: key,
          downstreamParentKey: parentKey,
          downstreamDepartmentCode: code,
          downstreamDepartmentName: name
        }
      };
      this.$refs.AppDetailPointModal.setLoading(true);
      let res = await saveDepartmentMappings(params);
      this.$refs.AppDetailPointModal.setLoading(false);
      if (res.data && res.data.result == 0) {
        if (dataValue.key) {
          this.$Message.success($t("at3ogg4", "关联成功"));
        } else {
          this.$Message.success($t("jk1gy76", "解除关联成功"));
        }
        this.getTree();
        this.$refs.AppDetailPointModal.close();
      }
    },
    /*
     * 选择应用
     */
    onSelectMenu(name) {
      this.activeValue = name;
      this.getTree();
    }
  }
};